export default __webpack_public_path__ + "static/media/icon-webchat.176f7015.svg";